import http from "../../http";

export default {
  getConfig: () => {
    return http.get("usertagservice/v1/tag/intent-config");
  },
  saveConfig: (data) => {
    return http.put("usertagservice/v1/tag/intent-config", data);
  },
  publish: (data) => {
    return http.post("usertagservice/v1/tag/intent-config/publish", data);
  },
};
